<template>
    <div v-if="status === statusDashboard.SUPERSET">
        <div v-if="supersetDashboards.length > 0" style="width: 100%;">
            <div style="width: 350px;" class="py-12 px-12">
                <v-select
                    hide-details
                    color="#0052CC"
                    v-model="dashboardIdActived"
                    :items="supersetDashboards"
                    item-text="title"
                    item-value="id"
                    class="input-custom"
                    style="margin-right: 0 !important;"
                ></v-select>
            </div>
            <div id="report_container"></div>
        </div>
        <div v-else class="display-flex align-center justify-center" style="padding: 40px 0; flex-direction: column">
            <img src="/img/superset-dashboard.png" alt="superset-dashboard-empty" style="width: 20%">
            <div class="empty-notice">{{ $f.tc('noDataAvailable') }}</div>
        </div>
    </div>
    <div v-else class="display-flex align-center justify-center" style="height: 70vh; font-size: 14px">
        <v-progress-circular
            indeterminate
            color="primary"
            class="mr-8"
        ></v-progress-circular>
        {{$f.tc('loadingData')}}
    </div>
</template>

<script>
import CampaignService from "@/services/campaign.service";

const supersetApiUrl = 'https://dap-explore.fpt.ai'
const statusDashboard = {
    CONNECTING: 'CONNECTING',
    SUPERSET: 'SUPERSET'
}

export default {
    name: "CampaignDetailsAnalytic",
    props: {
        campaign: Object
    },
    data() {
        return {
            statusDashboard,
            status: statusDashboard.CONNECTING,
            dashboardIdActived: '',
            supersetDashboards: []
        }
    },
    mounted () {
        this.initSupersetDashboard()
    },
    beforeDestroy() {
        let scriptSDKImport = document.getElementById("reportScriptImport")
        let scriptGuestTokenImport = document.getElementById("reportScriptInner")
        if (scriptSDKImport) {
            scriptSDKImport.remove()
        }
        if (scriptGuestTokenImport) {
            scriptGuestTokenImport.remove()
        }
    },
    methods: {
        initSupersetDashboard () {
            this.status = statusDashboard.CONNECTING
            this.getListSupersetDashboard().then(() => {
                this.status = statusDashboard.SUPERSET
            })
        },
        getListSupersetDashboard() {
            return CampaignService.getSupersetDashboards(this.$route.params.campaignId).then(result => {
                this.supersetDashboards = result.data
                this.dashboardIdActived = this.supersetDashboards[0] ? this.supersetDashboards[0].id : ''
            })
        },
        async showSupersetDashboard() {
            if (!this.dashboardIdActived) {
                return
            }
            // create script tag import sdk.js
            let scriptSDKImport = document.getElementById("reportScriptImport")
            if (!scriptSDKImport) {
                let sdkScript = document.createElement("script")
                sdkScript.setAttribute("src", "/assets/superset/embed.sdk.js")
                sdkScript.setAttribute("type", "module")
                sdkScript.setAttribute("id", "reportScriptImport")
                document.head.appendChild(sdkScript)
            }
            // create script call api get guest_token
            let scriptGuestTokenImport = document.getElementById("reportScriptInner")
            if (!scriptGuestTokenImport) {
                let recaptchaScript = document.createElement("script")
                recaptchaScript.setAttribute("id", "reportScriptInner")
                recaptchaScript.innerHTML = `
                  window.dataLayer = [];
                  function ftag(){window.dataLayer.push(arguments);}
                  ftag('__container', 'report_container');
                  ftag('__supersetDomain', '${supersetApiUrl}');
                  ftag('__appTokenApi', '${process.env.VUE_APP_BASE_API_URL}/campaigns/${this.$route.params.campaignId}/superset/guest-token/');
                  ftag('__dashboardId', '${this.dashboardIdActived}');
                  ftag('__jwtKey', 'jwToken');
                  ftag('__hideTitle', false);
                  ftag('__hideTab', false);
                  ftag('__hideChartControls', false);
                  ftag('__width', '100%');`
                document.head.appendChild(recaptchaScript)
            }
        },
        reloadDashboard() {
            let dashboardIdActived = this.dashboardIdActived ? this.dashboardIdActived : (this.supersetDashboards[0] ? this.supersetDashboards[0].id : '')
            let isDashboardSuperset = this.status === statusDashboard.SUPERSET
            if (dashboardIdActived && window.report && isDashboardSuperset) {
                window.report.reload(dashboardIdActived, { campaignId : this.$route.params.campaignId })
            }
        }
    },
    watch: {
        'dashboardIdActived': 'reloadDashboard',
        'supersetDashboards': {
            deep: true,
            handler: 'showSupersetDashboard'
        },
    }
}
</script>

<style scoped lang="scss">
.empty-notice {
    text-align: center;
    color: #4D6487;
    font-size: 14px;
    font-family: 'open sans';
    margin-top: 20px;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.btn-disable {
    font-family: "open sans" !important;
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    #report_container {
        iframe {
            width: 100%;
            height: calc(100vh - 263px);
            border-top: 1px solid #e4edfa;
        }
    }
}
</style>
